<div class="row text-center">
  <div class="col">
    <div class="header-icon margin-bottom mb8" [ngClass]="{'margin-bottom mb24': !isAcmic}">
      <figure>
        <ng-container *ngIf="isAcmic; else maIcon">
          <img src="./assets/img/images/account-warning-acmic.svg" alt="existing account"/>
        </ng-container>
        <ng-template #maIcon>
          <img src="./assets/img/images/account-warning-ma.svg" alt="existing account"/>
        </ng-template> 
      </figure>
    </div>
    <h1 class="account-exist-heading title-copy font-weight-normal margin-top mt-2">{{ "EXISTING_ACCT" | translate }}</h1>
    <p class="account-exist-heading-para para mb-4">{{ "OUR_RECORDS_INDICATE_ALREADY_CREATED_ONLINE_ACCT" | translate }}</p>
    <P class="account-exist-mail" [ngClass]="{ 'mb-4 font-medium font-weight-bold': !isAcmic }">{{ email }}</P>
    <p class="account-exist-recognize" [ngClass]="{ 'para recognize-mail mb-4 brand-lite-blue': !isAcmic }">{{ "IF_YOU_RECOGNIZE_THIS_EMAIL_LOG_YOUR_ACCT" | translate }}</p>
    
    <mapfre-button
      additionalClasses="basic primary large-btn account-exist-login"
      [routerLink]="['/login']"
    >
      {{ "LOGIN_ACCOUNT_EXISTS" | translate }}
    </mapfre-button>
    <!-- <div class="mt24">
   
      <mapfre-button
        additionalClasses="{{isAcmic ? 'link-button blue-link small f-password' : 'ghost warn-ghost secondary small-btn'}}"
        (click)="prefillEmailParamater()"
      >
        {{ "FORGOT_PASS" | translate }}
      </mapfre-button>
    </div> -->
    <p class="account-exist-not-recognize para cust-ser-dept mt-4 mb-2 brand-lite-blue">
      {{ "IF_YOU_DONT_RECOGNIZE_THE_EMAIL_CONTACT_CUST_SER_DEPT" | translate }}
    </p>
    <div>
        <a href="tel:{{ 'CUSTOMER_SERVICE_NUMBER' | translate }}" class="account-exist-tel mapfre link blue-link">
          {{ "CUSTOMER_SERVICE_NUMBER" | translate }}
        </a>
      </div>
  </div>
</div>
<div class="row text-center margin-top mt24">
  <div class="col">
    <ng-container *ngIf="isAcmic else ma" >
      <mapfre-button
      additionalClasses="link-button red-link small w-100 button-border-red account-exist-back"
      [backIcon]="'./assets/img/images/okta-acmic-arrow-left.svg'"
      [iconClasses]="'align-middle pr-1'"
      [routerLink]="['/signup']"
      [showIconsCustom]="true"
    >
      {{ "BACK" | translate }}
    </mapfre-button>
    </ng-container>
    <ng-template #ma>
      <mapfre-button
      additionalClasses="link-button red-link small w-100 button-border-red account-exist-back"
      [backIcon]="'./assets/img/icons/back-arrow-red.png'"
      [iconClasses]="'align-middle'"
      [routerLink]="['/signup']"
      [showIconsCustom]="true"
    >
      {{ "BACK" | translate }}
    </mapfre-button>
    </ng-template>
    
  </div>
</div>
